package utils

sealed interface FormFactor {
    data object Compact : FormFactor
    data object Medium : FormFactor
    data object Expanded : FormFactor
    data object ExtraLarge : FormFactor

    fun FormFactor.isCompact() = this == Compact
}